import {BusinessDetails, ContactDetails, GoogleDetails, MetaTagsProps, SocialMediaProfilesTypes} from "@/types";

export const BUSINESS_NAME: string = "Proelec Group";
export const WEBSITE_URL: string = "https://proelecgroup.com.au";
export const OG_PATH = `${WEBSITE_URL}/images/og/`;
export const defaultMetaTags: MetaTagsProps = {
    title: "Proelec Group | Level 2 Electrical Services in Sydney",
    description: "Proelec Group offers expert Level 2 electrical services in Sydney, including overhead and underground service installations, meter box upgrades, and emergency repairs. Our licensed ASP electricians ensure safe and reliable solutions for your home or business.",
    keywords: "Level 2 electrical services Sydney, ASP electrician Sydney, overhead service installation, underground service installation, meter box upgrade Sydney, emergency electrical repairs, electrical safety Sydney, licensed electricians Sydney",
    url: WEBSITE_URL,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const socialMediaProfiles: SocialMediaProfilesTypes = {
    instaLink: "https://www.instagram.com/",
    instaHandle: "",
    instaPostsLink: "https://www.instagram.com/p/",
    tikTokLink: "https://www.tiktok.com/",
    tikTokHandle: "",
    tikTokPostsLink: "https://www.tiktok.com/",
    facebookLink: "https://www.facebook.com/",
    facebookHandle: "",
    linkedInLink: "https://www.linkedin.com/company/",
    linkedInHandle: "",
    youTubeHandle: "",
    youTubeLink: "https://youtube.com/",
}

export const contactDetails: ContactDetails = {
    contactNumberOne: "0414 545 858",
    contactNumberTwo: "",
    contactEmail: "info@proelecgroup.com.au",
}

export const googleDetails: GoogleDetails = {
    googleHandle: "",
    googleLink: "",
    googleMaps: "",
    googleReviewLink: "https://g.page/r/CYPiKpabk5Q6EAE/review",
    googleServiceArea: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d424141.6978944982!2d150.93197474999997!3d-33.84824395!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xf220192f07f1fef%3A0x3a94939b962ae283!2sProelec%20Group!5e0!3m2!1sen!2sau!4v1757846581684!5m2!1sen!2sau",

    areaServed: "Sydney",
    serviceAreaLatLong: {
        latitude: -33.9180, // Sydney
        longitude: 151.0346
    }

}

export const businessDetails: BusinessDetails = {
    branding: {
        headerLogoUrl: "/images/logos/proelect.svg",
        footerLogoUrl: "/images/logos/proelect-2.svg",
    },
    companyData: {
        abn: "",
        address: "",
        licenseNumber: "",
    },
    captchaKeys: {
        dev: "6LeDLn4UAAAAAPW2RFlXvgusfkU9e_n4Q7zFtpQj",
        prod: "6LcP3p0oAAAAAOLrgJTbudQ5pkckcNng9CJtxr1M",
    },
    address: {
        streetAddress: "123 High St",
        addressLocality: "Bankstown",
        addressRegion: "NSW",
        postalCode: "2200",
        addressCountry: "AU"
    },
    serviceAreas: [
        "Sydney CBD",
        "Inner West",
        "Eastern Suburbs",
        "Lower North Shore",
        "Upper North Shore",
        "Northern Beaches",
        "Western Sydney",
        "Southern Sydney",
        "Sutherland Shire",
        "Greater Western Sydney",
    ],
    generalServiceArea:'Sydney'
};
